<template>
  <hello-world />
</template>

<script>
  import HelloWorld from '../components/hello-world'

  export default {
    name: 'home-view',

    components: {
      HelloWorld,
    },
  }
</script>
